import { useCachedSelectedProject } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setActiveReport, toggleHistoryMode } from 'store/slices/historySlice';

/**
 * useHistoryModeToggle
 * Shared entry point for switching history mode on/off from the Banner and
 * the ReportProgressBar's "Report History" button.
 *
 * While a new report is generating, reports[0] is the in-progress BUSY
 * placeholder — entering history mode must populate activeReport with the
 * most recent *completed* report instead of leaving it undefined, or every
 * report-scoped data hook keeps fetching the in-progress report's (empty)
 * data while the UI claims to show a past one.
 */
export const useHistoryModeToggle = () => {
  const { selectedProject } = useCachedSelectedProject();
  const dispatch = useAppDispatch();
  const historyMode = useAppSelector(state => state.history.historyMode);

  const previousReport = selectedProject?.reports?.find(
    r => r.status !== 'BUSY' && r.status !== 'ERROR'
  );

  const handleToggleHistoryMode = () => {
    dispatch(toggleHistoryMode());
    dispatch(setActiveReport(historyMode ? undefined : previousReport));
  };

  return { historyMode, previousReport, handleToggleHistoryMode };
};
